/* eslint-disable max-len */
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { ResponsiveImage } from '../../atoms/image/ResponsiveImage';
import VideoPlayer from '../../atoms/VideoPlayer';
import { Image } from '../../atoms/image/Image';

export const TeaserMedia = ({
  image = null,
  video = null,
  spacing = 'none',
  background = '',
  hideImageOnMobile = false,
  styles = {
    video: '',
    wrapper: '',
    image: '',
  },
  overlayTheme = 'dark',
  isOverlay,
  isMobile,
  imageMobile,
  videoMobile,
  mediaLoading,
  preloadImage,
  showVideoControls,
  breakpoint = {},
}) => {
  const imageRef = useRef(null);
  const [orientation, setOrientation] = useState(null);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    const aspectRatio = image?.ratio?.split(':').map(Number);
    if (aspectRatio?.length === 2) {
      const [w, h] = aspectRatio;
      if (w > h) setOrientation('landscape');
      else if (w < h) setOrientation('portrait');
      else setOrientation('even');
    }
  }, [image?.ratio]);

  const shouldHideMedia = hideImageOnMobile && breakpoint.small;

  const videoUrl = (isMobile ? videoMobile : video) || (image?.media?.resourceType === 'video' && image?.media?.file);

  const showVideo = hasMounted && !shouldHideMedia && videoUrl;
  const showImage = !showVideo && !shouldHideMedia && image?.media?.file;

  const imageClasses = clsx(styles.image, {
    [styles[`imageSpacing__${spacing}`]]: spacing !== 'none',
    [styles[`overlay_${overlayTheme}`]]: isOverlay,
    [styles[`image__${orientation}`]]: spacing !== 'none',
  });

  return (
    <div
      style={{ backgroundColor: background }}
      className={clsx(styles.wrapper, {
        [styles[`overlay_${overlayTheme}`]]: isOverlay,
      })}
    >
      {showVideo && (
        <div className={imageClasses}>
          <VideoPlayer
            url={videoUrl}
            aspectRatio={image?.ratio?.replace(':', '/')}
            controls={showVideoControls}
            muted
            onReady={() => {
              imageRef?.current?.remove();
            }}
          />
        </div>
      )}

      {showImage && (
        <div className={imageClasses}>
          {image.media.file.includes('/media.') ? (
            <ResponsiveImage mobileSource={imageMobile} source={image} loading={mediaLoading} preload={preloadImage} />
          ) : (
            <Image
              alt={image?.name}
              title={image?.name}
              itemProp="image"
              image={isMobile && imageMobile?.media?.file ? imageMobile.media.file : image.media.file}
            />
          )}
        </div>
      )}
    </div>
  );
};
